import api from "./client";

// AI Activity — the ledger's human-readable face (read-only). Rows are composed
// BACKEND-side from real ExecutionLedger fields (counters-from-truth), so the
// frontend renders summary/detail verbatim and never re-derives a count.
//
//   GET /agent/activity/?action_type=&state=&day=YYYY-MM-DD&limit=&cursor=
//     -> { activity: [{ id, action_type, state, summary, detail, created_at,
//                       surface, subject:{type,id,label} }],
//          counts: { total, by_action_type, by_state }, next }
//   Sorted created_at DESC (newest first). Keyset cursor.

export const listActivity = ({ action_type, state, day, limit = 50, cursor } = {}) =>
  api.get("/agent/activity/", {
    params: {
      ...(action_type ? { action_type } : {}),
      ...(state ? { state } : {}),
      ...(day ? { day } : {}),
      limit,
      ...(cursor ? { cursor } : {}),
    },
  });
